import React, { useMemo } from 'react'
import ViewCollapse from 'components/view-collapse'

const ShotList = ({ title, entity, isCollapses = true }) => {
  const shortsList = useMemo(() => {
    return entity && entity.shots
      ? entity.shots.split('\n').map((el, index) => <p key={index}>{el}</p>)
      : null
  }, [entity.shots])
  return isCollapses ? (
    <ViewCollapse title={title}>
      <div className="live-target__list">{shortsList}</div>
    </ViewCollapse>
  ) : (
    <div>
      <div className="live-target__head--static">{title}</div>
      <div className="live-target__list">{shortsList}</div>
    </div>
  )
}

export default ShotList
